// extracted by mini-css-extract-plugin
export default {"popupDialog":"Alert_popupDialog__jCaTS","title":"Alert_title__KHpi+","noSidePadding":"Alert_noSidePadding__7ywNX","templatesPopup":"Alert_templatesPopup__DLSj-"};